const tracksValidationEN = {
    "trackName": {
        "required": "The track name is required",
        "length": "The track name must be more than 1 and less than 255 characters long",
        "regexp": "The track name can only consist of alphabetical, number, space and underscore"
    },
    "mix_name": {
        "required": "Please type mix name",
        "regexp": "The mix name can only consist of alphabetical, number, space and underscore"
    },
    "artistName": {
        "required": "Please select artist"
    },
    "artistType": {
        "required": "Please select artist type"
    },
    "atleastOneMainArtist": {
        "required": "At least one artist have to be main"
    },
    "duplicateArtists": {
        "required": "There are two or more artists with same name."
    },
    "publisherName": {
        "required": "Please select publisher"
    },
    "publisherAuthor": {
        "required": "Please insert the real First and Last name of the person."
    },
    "contributorName": {
        "required": "Please select contributor"
    },
    "contributorRole": {
        "required": "Please select contributor role"
    },
    "atleastOneComposer": {
        "required": "At least one Contributor should be Composer"
    },
    "atleastOneLyricist": {
        "required": "At least one Contributor should be Lyricist"
    },
    "copyright": {
        "required": "Copyright is required",
        "regexp": "The copyright can only consist of alphabetical, number, space and underscore"
    },
    "copyrightYear": {
        "required": "Copyright Year is required",
        "regexp": "The copyright year must be a valid year"
    },
    "ISRC": {
        "required": "Please provide ISRC or mark Generate ISRC",
        "regexp": "Please insert valid ISRC code or leave empty"
    },
    "DA_ISRC": {
        "required": "Please provide Dolby Atmos ISRC or mark Generate ISRC",
        "regexp": "Please insert valid ISRC code or leave empty"
    },
    "trackLanguage": {
        "required": "Track Language is required. Please select the language of your track name."
    },
    "trackVocals": {
        "required": "Track vocal is required. Please select the language of your vocals."
    },
    "trackGenre": {
        "required": "Please select your track Genre."
    },
    "trackSubGenre": {
        "required": "Please select your track Sub-Genre"
    },
    "featuringArtistMissing": {
        "required": "Track must have the featured artist listed in the title correctly assigned a featured artist role. Please amend and resubmit."
    },
};

export default tracksValidationEN; 